"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableCell = void 0;
var React = require("react");
var Icons_1 = require("../../../Icons/");
var EditableCell_styles_1 = require("./EditableCell.styles");
var colorNormal = "#C5C9D1";
var colorHover = "#0074D9";
var EditableCell = function (_a) {
    var value = _a.value;
    var _b = React.useState(colorNormal), iconColor = _b[0], setIconColor = _b[1];
    return (React.createElement(EditableCell_styles_1.CellContents, { onMouseEnter: function () { return setIconColor(colorHover); }, onMouseLeave: function () { return setIconColor(colorNormal); } },
        React.createElement(EditableCell_styles_1.IconBox, { Color: iconColor },
            React.createElement(Icons_1.EditIcon, { Height: "24px", Width: "24px" })),
        React.createElement(EditableCell_styles_1.CellTextValue, null, value)));
};
exports.EditableCell = EditableCell;
